<template>
	<a
		class="nav-meta__list-item-link"
		@click.prevent="onClick"
		href="javascript:void(0)"
	>
		<span
			class="nav-meta__list-item-text"
			v-html="$t('reservation.iconLabel')"
		/>
		<SVGIndining
			class="nav-meta__list-item-icon"
		/>
	</a>
</template>

<script>
export default {
	methods: {
		onClick() {
			this.$store.dispatch('redirect', {name: 'reservation'})
		}
	}
}
</script>
